import type { PartnerSiteConfig } from '../models/partnerSite.interface';
import { PlatformType } from '../models/platformType.type';
import { THEME_IDS } from './themes.const';

const httpsPartnerSites: PartnerSiteConfig[] = [
  {
    origin: 'https://navka-arena-p4bavqoxw-ahoryakovs-projects.vercel.app',
    themeId: THEME_IDS.LIGHT,
    platformType: PlatformType.NAVKA_ARENA,
  },
  {
    origin: 'https://navkaarena.ru',
    themeId: THEME_IDS.LIGHT,
    platformType: PlatformType.NAVKA_ARENA,
  },
  {
    origin: 'https://widget.test.colistasystems.ru',
    themeId: THEME_IDS.LIGHT,
    platformType: PlatformType.NAVKA_ARENA,
  },
  {
    origin: 'https://navka-arena.vercel.app',
    themeId: THEME_IDS.LIGHT,
    platformType: PlatformType.NAVKA_ARENA,
  },
  {
    origin: 'https://navka.show',
    themeId: THEME_IDS.LIGHT,
    platformType: PlatformType.NAVKA_SHOW,
  },
];

const localhostPartnerSite: PartnerSiteConfig = {
  origin: 'http://localhost:9001',
  themeId: THEME_IDS.LIGHT,
  platformType: PlatformType.NAVKA_ARENA,
};

const allowLocalhost = import.meta.env.MODE === 'development' || import.meta.env.MODE === 'staging';

export const partnerSites: PartnerSiteConfig[] = allowLocalhost
  ? [...httpsPartnerSites, localhostPartnerSite]
  : httpsPartnerSites;
